import { ArrowUpRight, Linkedin } from "lucide-react";
import { ARTICLES, LINKS } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Articles = () => (
  <section id="artigos" className="bg-white py-20 lg:py-32" data-testid="articles-section">
    <Container>
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Overline>Conteúdo</Overline>
          <MaskText className="font-display mt-6 text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl"
            lines={["Artigos e atividade", <>no <span className="text-[#1238CE]">LinkedIn.</span></>]} />
        </div>
        <Reveal>
          <a href={LINKS.linkedin} data-testid="articles-linkedin-link"
            className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-[#0F172A] transition-colors hover:border-[#1238CE] hover:text-[#1238CE]">
            <Linkedin size={16} /> Ver perfil no LinkedIn
          </a>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {ARTICLES.map((a, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <a href={LINKS.linkedin} data-testid={`article-card-${i}`}
              className="group flex h-full min-h-[300px] flex-col justify-between rounded-[24px] border border-slate-200 bg-[#F4F6FB] p-7 transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-[#060B19]">
              <div className="flex items-center justify-between">
                <span className="font-mono-x rounded-full bg-white px-3 py-1 text-[11px] uppercase tracking-[0.15em] text-[#1238CE]">{a.tag}</span>
                <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-[#0F172A] transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-[#CCFF00]">
                  <ArrowUpRight size={18} />
                </span>
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold leading-snug text-[#0F172A] transition-colors duration-500 group-hover:text-white sm:text-2xl">{a.t}</h3>
                <span className="mt-6 inline-block text-sm font-bold text-[#1238CE] transition-colors duration-500 group-hover:text-[#CCFF00]">Ler artigo →</span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);
